<template>
	<modal
		:modal-id="userAndRoles.users.manageCentreModalId"
		:title="modalTitle"
		:preloader="preloader"
		:modal-scroll="false"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				ref="form"
				:data-url="
					hasData
						? `user-centre/${userAndRoles.rowData.id}`
						: `user-centre`
				"
				:class="{ 'loading-opacity': preloader }"
			>
				<!-- Center ID -->
				<div class="form-group row align-items-center">
					<label for="user_center_id" class="col-sm-3 mb-0">
						{{ $t("center") }}
					</label>

					<app-input
						id="user_center_id"
						class="col-sm-9"
						placeholder="Center"
						type="multi-select"
						:list="centerLists"
						name="center_id"
						v-model="user.center_id"
						:isAnimatedDropdown="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import { UserAndRoleMixin } from "../Mixins/UserAndRoleMixin";
import * as actions from "../../../../Config/ApiUrl";

export default {
	name: "ManageCentreModal",
	mixins: [FormMixin, ModalMixin, UserAndRoleMixin],
	props: {
		value: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	data() {
		return {
			user: {},
			roles: [],
			roleLists: [],
			centerLists: [],
			hasData: false,
			modalTitle: this.$t("invite_users"),
		};
	},
	created() {
		if (!_.isEmpty(this.userAndRoles.rowData)) {
			this.hasData = true;
			(this.modalTitle =
				"Manage Centre - " +
				this.userAndRoles.rowData.full_name),
				(this.user.email = this.userAndRoles.rowData.email);
			this.roles = this.userAndRoles.rowData.roles.map(function (roles) {
				return roles.id;
			});
			if (this.userAndRoles.rowData.centers != null) {
				this.user.center_id = this.userAndRoles.rowData.centers.map(
					(center) => {
						return center.id;
					}
				);
			}
		}
		this.getRoles();
		this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				let [centerResponse] = await Promise.all([
					axios.get("/master/center?per_page=1000"),
				]);

				centerResponse.data.data.map((item) => {
					this.centerLists.push({
						id: item.id,
						value: item.name,
					});
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
			delete this.user.email;
			this.user.user_id = this.userAndRoles.rowData.id;
			this.save(this.user, null, this.hasData);
		},

		afterSuccess(res) {
			this.$toastr.s(res.data.message);
			this.reLoadTable();
		},
		getRoles() {
			let url = actions.ROLES;

			this.preloader = this.hasData ? true : false;

			this.axiosGet(url)
				.then((response) => {
					this.roleLists = response.data.data;
				})
				.catch(({ response }) => {})
				.finally(() => {
					this.preloader = false;
				});
		},
	},
};
</script>
